import React from "react";
import { Box, Typography, Grid, useMediaQuery, useTheme } from "@mui/material";
import Quotes from "images/quotes.svg";

/** Reviews longer than this get a fixed-height area with a scrollbar. */
const LONG_TEXT_THRESHOLD = 320;

const CarouselReviewItem = ({ carouselItem, index }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const reverse = index % 2 === 1;
  const isLongReview = carouselItem.text.length > LONG_TEXT_THRESHOLD;
  const isPlaceholder = Boolean(carouselItem.pictureIsPlaceholder);

  const avatarImgStyle = (compact) => ({
    borderRadius: "50%",
    height: compact ? "60px" : "260px",
    width: compact ? "60px" : "260px",
    marginTop: compact ? 0 : "40px",
    marginRight: compact ? "12px" : undefined,
    objectFit: isPlaceholder ? "contain" : "cover",
    objectPosition: isPlaceholder ? "center" : (carouselItem.imagePosition || "center"),
    backgroundColor: isPlaceholder ? "#f5f9fc" : undefined,
    padding: isPlaceholder ? (compact ? "6px" : "16px") : undefined,
    boxSizing: "border-box",
    border: isPlaceholder ? `1px solid ${theme.palette.grey[300]}` : undefined,
  });

  return (
    <Grid
      container
      spacing={isDesktop ? 4 : 0}
      alignItems="center"
      direction={isDesktop && reverse ? "row-reverse" : "row"}
      justifyContent="center"
      sx={{
        minHeight: isDesktop ? 560 : 568,
        py: 1,
        maxWidth: "100%",
        mx: "auto",
      }}
    >
      <Grid item xs={12} md={6} style={{ paddingTop: 0, display: 'flex', justifyContent: reverse ? 'flex-start' : 'flex-end' }}>
        <Box
          textAlign="center"
          style={{
            width: isDesktop ? "380px" : "86%",
            maxWidth: "100%",
            boxSizing: "border-box",
            marginLeft: isDesktop ? (reverse ? 'unset' : 'auto') : 'auto',
            marginRight: isDesktop ? (reverse ? 'auto' : 'unset') : 'auto',
          }}
        >
          <img
            src={Quotes}
            alt="Quotes"
            style={{ width: "50px", height: "50px" }}
          />
          <Typography
            variant="h5"
            component="div"
            sx={{
              fontStyle: "italic",
              marginTop: "30px",
              marginBottom: "30px",
              fontSize: isDesktop ? "18px !important" : "17px !important",
              lineHeight: 1.5,
              padding: isDesktop ? "unset" : "8px 0",
              ...(isLongReview
                ? {
                    maxHeight: isDesktop ? 300 : 240,
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: "8px",
                    scrollbarGutter: "stable",
                    scrollbarWidth: "thin",
                    scrollbarColor: `${theme.palette.grey[500]} ${theme.palette.grey[200]}`,
                    "&::-webkit-scrollbar": {
                      width: 8,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: theme.palette.grey[200],
                      borderRadius: 4,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: theme.palette.grey[500],
                      borderRadius: 4,
                    },
                  }
                : {}),
            }}
          >
            {carouselItem.text}
          </Typography>
          {!isDesktop && (
            <Box display="flex" alignItems="center" justifyContent="center" marginTop="20px">
              <img
                src={carouselItem.picture}
                srcSet={isPlaceholder ? undefined : `${carouselItem.picture} 1x, ${carouselItem.picturesmall} 0.5x`}
                alt={carouselItem.alt || carouselItem.name}
                style={avatarImgStyle(true)}
              />
              <Box>
                <Typography variant="h5" style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {carouselItem.name} - {carouselItem.date}
                </Typography>
                <Typography
                  variant="h7"
                  style={{ fontSize: isDesktop ? "14px" : "12px" }}
                >
                  {carouselItem.position}
                </Typography>
              </Box>
            </Box>
          )}
          {isDesktop &&
            <>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", marginTop: "20px", fontSize: "18px" }}
              >
                {carouselItem.name} - {carouselItem.date}
              </Typography>
              <Typography
                variant="h7"
                style={{ fontSize: isDesktop ? "14px" : "12px" }}
              >
                {carouselItem.position}
              </Typography>
            </>
          }
        </Box>
      </Grid>
      {isDesktop && (
        <Grid
          item
          xs={12}
          md={6}
          style={{ paddingTop: 0, display: 'flex', justifyContent: reverse ? 'flex-end' : 'flex-start', paddingLeft: reverse ? "unset" : "100px", paddingRight: reverse ? "100px" : "unset" }}
        >
          <img
            src={carouselItem.picture}
            srcSet={isPlaceholder ? undefined : `${carouselItem.picture} 1x, ${carouselItem.picturesmall} 0.5x`}
            alt={carouselItem.alt || carouselItem.name}
            style={avatarImgStyle(false)}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CarouselReviewItem;
